import http from "api/httpClient";

export type CellColor = "RED" | "GREEN";

export type Cell = {
    value: number | null;
    color: CellColor;
    display: string;
};

export type RuleKey =
    | "MRR"
    | "CM"
    | "OVERDUE_60D"
    | "UNBILLED_EXCL_STOCK"
    | "FRAGMENTATION"
    | "CREDIT_LIMIT";

export type CustomerHealthRow = {
    customer_code: string;
    customer_name: string;
    mrr: Cell;
    cm_pct: Cell;
    overdue_gt_60d: Cell;
    unbilled_excl_stock: Cell;
    fragmentation: Cell;
    credit_limit_breached: Cell;
    distinct_branches: number;
    red_count: number;
};

export type SortField =
    | "customer_name"
    | "customer_code"
    | "mrr"
    | "cm_pct"
    | "overdue_gt_60d"
    | "unbilled_excl_stock"
    | "long_tail_share"
    | "distinct_branches"
    | "credit_limit_breached"
    | "red_count";

export type SortDir = "asc" | "desc";

export type CustomerHealthRequest = {
    search?: string;
    red_rules?: RuleKey[];
    sort?: { by: SortField; dir: SortDir };
    page?: number;
    page_size?: number;
    final_accountability_ecode?: string;
};

export type CustomerHealthResponse = {
    total: number;
    items: CustomerHealthRow[];
};

export async function fetchCustomerHealth(
    payload: CustomerHealthRequest
): Promise<CustomerHealthResponse> {
    return http.post("/api/v1/dashboard/customer-health/fetch-data", payload);
}

export async function downloadCustomerHealthExcel(payload: CustomerHealthRequest): Promise<Blob> {
    return http.post("/api/v1/dashboard/customer-health/download-excel", payload, {responseType: "blob"});
}

export type AccountabilityPerson = { ecode: string; name: string };
export type AccountabilityPeopleResponse = { items: AccountabilityPerson[] };

export async function fetchAccountabilityPeople(): Promise<AccountabilityPeopleResponse> {
    return http.get("/api/v1/dashboard/customer-health/accountability-people");
}